export default __webpack_public_path__ + "static/media/dtsu5168_direct_master_4p.7ffc1875.jpg";